















import { container } from 'tsyringe';
import { defineComponent, watch, Ref, ref } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import { ModelManager } from '@/prototyping/model';

export default defineComponent({
  components: { ViewContainer },
  name: 'Library',
  setup() {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');
    audioPlayer.sortAudioTracks(audioLib.state.audioLib);

    function inMin(time) {
      const min = Math.floor(time / 60);
      const sec = Math.floor(time % 60);
      const secPadded = `${sec < 10 ? '0' : ''}${sec}`;
      return `${min}:${secPadded}`;
    }

    function playAudioTrack(id) {
      if (id !== audioPlayer.currentAudioTrack.value?.id) audioPlayer.setCurrentAudioTrack(id);
      if (!audioPlayer.isPlaying.value) audioPlayer.togglePlay();
    }

    // TODO? add typing
    // eslint-disable-next-line
    const audioEntries: Ref<any[]> = ref([]);

    watch(
      [() => audioPlayer.state.queue, audioPlayer.currentAudioTrack, () => audioLib.state.audioLib],
      async () => {
        audioEntries.value = (
          await Promise.all(
            audioPlayer.state.queue.map(async (at) => {
              const audioTrackInfo = audioLib.state.audioLib.find((ti) => ti.audioFile?.filename === at.src || ti.newAudioFile?.audio === at.src);
              const duration = {
                duration:
                  audioTrackInfo?.newAudioFile && audioTrackInfo.newAudioFile.duration > 0 ? audioTrackInfo.newAudioFile.duration : audioTrackInfo?.duration,
              };
              const audioInfo = {
                id: at.id,
                isActive: audioPlayer.currentAudioTrack.value?.id === at.id,
                artist: '',
              };
              return audioTrackInfo ? { ...audioInfo, ...audioTrackInfo, ...duration } : { ...audioInfo, ...duration };
            })
          )
        );
      },
      { immediate: true }
    );

    return { audioEntries, playAudioTrack, inMin };
  },
});
